import React from "react";
import { format } from "date-fns";

export default function RestlessUserDateFormatter(cellContent) {
  const date = cellContent
    ? format(new Date(cellContent), "MMMM dd, yyyy")
    : "No date registered";
  return (
    <div>{date}</div>
  );
}